import ErrorSVG from '@/static/icons/info_red.svg'
import InfoSVG from '@/static/icons/info_dark_grey.svg'

export default {
  name: 'alert',
  components: {},
  props: {
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['info', 'success', 'warning', 'error'].includes(value)
    },
    title: {
      type: String,
      default: () => ''
    },
    message: {
      type: String,
      default: () => ''
    },
    hideCloseBtn: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: String,
      default: 'compact',
      validator: (value) => ['compact', 'medium'].includes(value)
    }
  },
  computed: {
    imageSource () {
      return this.type === 'error' ? ErrorSVG : InfoSVG
    }
  }
}
